export default __webpack_public_path__ + "static/media/blackgram.4b2eef2a.png";